import { css } from '@emotion/css'
import { accessiblyHidden } from '@offerzen/pinata'

const styles = {
  accessiblyHidden: css(accessiblyHidden),
}

export default styles
